import React from "react";
import { Checkbox } from "antd";
import { RightOutlined } from "@ant-design/icons";
import MediaFetcher from "../library/MediaFetcher";

const GroupListRow = ({ group, selected, onSelect, onClick }) => {
  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    onSelect(group.id);
  };

  const medias = group.medias || [];
  const galleryMedias = medias.slice(0, 4);

  return (
    <div
      className={`creative-group-row${selected ? " creative-group-row--selected" : ""}`}
      onClick={() => onClick(group)}
    >
      <div className="creative-group-row__checkbox">
        <Checkbox
          checked={selected}
          onClick={handleCheckboxClick}
        />
      </div>

      <div className="creative-group-row__gallery">
        {[0, 1, 2, 3].map((idx) => {
          const media = galleryMedias[idx];
          return (
            <div key={idx} className="creative-group-row__gallery-cell">
              {media && media.key ? (
                <MediaFetcher
                  mediaKey={media.key}
                  width="100%"
                  height="100%"
                  objectFit="cover"
                />
              ) : null}
            </div>
          );
        })}
      </div>

      <div className="creative-group-row__content">
        <div className="creative-group-row__name" title={group.name}>
          {group.name || "Untitled Group"}
        </div>
        <div className="creative-group-row__meta">
          {medias.length} unit{medias.length !== 1 ? "s" : ""}
        </div>
      </div>

      <div className="creative-group-row__chevron">
        <RightOutlined />
      </div>
    </div>
  );
};

export default GroupListRow;
